export function normalizeMappingProjectKey(projectKey: string | null | undefined): string | null {
  const normalized = projectKey?.trim().replace(/\//g, '\\').toLowerCase();
  return normalized ? normalized : null;
}
